define(['jquery', 'libs/underscore-min', 'libs/backbone-min', 'libs/ba-tiny-pubsub.min'], function ($, _, Backbone) {
	'use strict';

	var BlockPageView = Backbone.View.extend({

		initialize: function (options) {
			this.template = 'start_page';

			// We can initiate this view on an already created element.
			if (options !== undefined && options.$el !== undefined) {
				this.setElement(options.$el);
				this.render();
				this._initEvents();
			}
		},


		render: function () {
			// summary:
			//		Renders the html with Handlebars.

			this.$el.html(Handlebars.templates[this.template](this.model.attributes));
			$.publish('initPageScripts', {initPageScripts: true});

			return this;
		},


		_addBlock: function (block) {
			// summary:
			//		Adds a block.

			if (Handlebars.templates[block.template] !== undefined) {
				var $blockHtml = $(Handlebars.templates[block.template](block));
				this.$el.append($blockHtml);
			}
		},


		_updateBlock: function (id, block) {
			// summary:
			//		Updates a block.

			if (Handlebars.templates[block.template] !== undefined) {
				var View = this,
					$target = this.$el.find('#' + id),
					$newContent = $(Handlebars.templates[block.template](block));

				$target.html($newContent.html());
				$.publish('initPageScripts', {initPageScripts: true});
			}
		},


		_updateSortOrder: function () {
			var blocks = $('.block-page-item').sort(function (a, b) {
				var indexA = $(a).find('> div').attr('data-index'),
					indexB = $(b).find('> div').attr('data-index');
				return indexA - indexB;
			});
			this.$el.find('.page').html(blocks);
		},


		_removeBlock: function (id) {
			// summary:
			//		Removes a block.

			if (this.$el.find('#' + id).length > 0) {
				this.$el.find('#' + id).remove();
			}
		},


		_initEvents: function () {
			// summary:
			//		Setup events.

			var View = this;

			this.listenTo(this.model, 'change', function () {
				_.each(View.model.changedAttributes(), function (value, key) {
					if (key === 'blockIds') {
						View._updateSortOrder();
					}
					else if (value === undefined && key.substr(0, 5) === 'block') {
						View._removeBlock(key);
					}
					else if (_.isObject(value) && value.id !== undefined) {
						if (value.isNew !== undefined) {
							View._addBlock(value);
						}
						else {
							View._updateBlock(key, value);
						}
					}
				});
			});
		}
	});

	return BlockPageView;
});


//////////////////
// WEBPACK FOOTER
// ./views/blockpage.view.js
// module id = 12
// module chunks = 0